import React, { useEffect, useState } from "react";

import { Card, CardHeader } from "@mui/material";
// Material Dashboard 2 React example components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import AsyncSelect from "react-select/async";
import AccountingApi from "../../../Classes/API/AccountingApi";
import Swal from "sweetalert2";
import searchUsersReq from "../../../Classes/Models/Requests/Users/SearchUser";
import UsersApi from "../../../Classes/API/UsersApi";
import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes";
import AddManyToManyReq from "../../../Classes/Models/Requests/AddManyToManyReq";
import { SettingsApplicationsRounded } from "@mui/icons-material";
const AddPatients = ({ Contract, setIsLoaded }) => {
  const [PatientsSearch, setPatientsSearch] = useState();
  const [Patient, setPatient] = useState({});

  const onSubmitClick = async () => {
    if (Object.keys(Patient) < 1) {
      Swal.fire({
        title: "Error",
        text: "Please select a patient",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    let req = new AddManyToManyReq();
    req.Id1 = Contract.id;
    req.Id2 = Patient.getPatient.id;

    let res = await AccountingApi.AddPatientToContract(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: res.message,
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        setIsLoaded(false);
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const GetPatients = async () => {
    let searchReq = new searchUsersReq();
    let UserTypes1 = new UserTypes();

    searchReq.name = PatientsSearch;
    searchReq.userType = UserTypes1.Patient;
    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item, label: item.name });
      });
      return optionsArr;
    }
  };

  return (
    <Card sx={{ padding: "1em" }}>
      <CardHeader title="Add Patient To Contract" />
      <MDBox mb={3}>
        <MDTypography variant="button" fontWeight="regular" color="text">
          Select Patient:
          <AsyncSelect
            isClearable={true}
            loadOptions={GetPatients}
            onInputChange={setPatientsSearch}
            onChange={(e) => setPatient(e ? e.value : "")}
            // value={TypeId}
          />
        </MDTypography>
      </MDBox>
      <MDButton onClick={() => onSubmitClick()} variant="standard" color="primary">
        Add To Contract {Contract.name}
      </MDButton>
    </Card>
  );
};

export default AddPatients;
